
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

const AdRequestSteps: React.FC = () => {
  return (
    <Card className="shadow-md border-0 bg-white/90">
      <CardHeader>
        <CardTitle className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <CheckCircle className="w-6 h-6 text-green-500" />
          Comment ça marche ?
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-indigo-600 font-semibold text-sm">1</span>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Soumettez votre demande</h4>
              <p className="text-gray-600 text-sm">Remplissez le formulaire avec vos informations de contact</p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-purple-600 font-semibold text-sm">2</span>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Nous vous contactons</h4>
              <p className="text-gray-600 text-sm">Notre équipe vous appelle dans les 24h pour discuter de vos besoins</p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-green-600 font-semibold text-sm">3</span>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Recevez vos offres</h4>
              <p className="text-gray-600 text-sm">Obtenez des propositions d'annonces personnalisées par email</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdRequestSteps;
